import React, { useEffect } from "react";
import { Button, Select } from "antd";
import { useItemsFine } from "../_actions/app/items";
import {
    InstagramOutlined,
    LinkedinOutlined,
    FacebookOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import { history } from "../_helpers/history";

function SocialAccountDropdown({
    org_id,
    platform = null,
    value,
    onChange,
    exclude = [],
    auto_configure = false,
}) {
    const {
        isSuccess: successSK,
        isLoading: loadingSK,
        data: dataSK,
        refetch: refetchSK,
    } = useItemsFine(
        "qdb_social_keys",
        `filter[organization][_eq]=${org_id}&fields=id,account_id,profile_picture,platform,profile_info`,
        true
    );

    const filteredAccounts = successSK
        ? dataSK.filter((i) => {
            if (exclude?.includes(i.id)) return false;
            return platform
                ? i.platform?.toLowerCase() === platform.toLowerCase()
                : true
        })
        : [];

    const options = filteredAccounts.map((item) => ({
        value: item.id,
        label: (
            <div>
                <span style={{ color: SOCIAL_PLATFORM_COLORS?.[item.platform] }}>{getIcon(item.platform)}</span>{" "}
                {item?.profile_info?.name || `${item.platform} User`}
            </div>
        ),
    }));

    useEffect(() => {
        if (auto_configure && !value) {
            if (options?.length > 0) {
                onChange(options[0].value);
            }
        }
    }, [auto_configure, options]);

    if (successSK && options?.length === 0) {
        return <div>
            <Button
                icon={<PlusOutlined />}
                onClick={() => {
                    history.push(`/settings/social-accounts`);
                }}
            >
                Connect social accounts
            </Button>
        </div>
    }

    return (
        <Select
            value={value}
            onChange={onChange}
            options={options}
            loading={loadingSK}
            placeholder="Select Account"
            style={{ width: "100%" }}
        />
    );
}

function getIcon(platform) {
    switch (platform) {
        case "Instagram":
            return <InstagramOutlined />;
        case "Linkedin":
            return <LinkedinOutlined />;
        case "Facebook":
            return <FacebookOutlined />;
        default:
            return null;
    }
}

const SOCIAL_PLATFORM_COLORS = {
    Instagram: "#E1306C",
    Linkedin: "#0077B6",
    Facebook: "#1877F2",
    Twitter: "#1DA1F2",
    Youtube: "#FF0000",
}

export default SocialAccountDropdown;
